<template>
  <div>
    <b-card>
      <b-row>
        <b-col><b-form-select v-model="filter" :options="options"></b-form-select></b-col>
        <b-col></b-col>
      </b-row>
        
        <b-table 
            :items="items" 
            :fields="fields" 
            caption-top
            small   
            show-empty
            empty-text="There are no breaches matching the current filter parameters"
            responsive
            sticky-header
            outlined
            id="BreachesTable"
            class="text-center">
            <template #table-caption>This table displays the details of the current compliance breaches within the location allowing users to identify patterns and root cause of issues</template>
            <template #thead-top>
        <b-tr>
          <b-th colspan="4" class="Head">Device Details</b-th>
          <b-th colspan='4' variant="secondary" class="Head">Temperatures</b-th>
          <b-th colspan='2' variant="info" class="Head" >Flow</b-th>
        </b-tr>
      </template>
      <template v-slot:cell(esc)="{ item }">
              <BIconExclamationCircle v-b-popover.hover.top="'This breach was escalated'" title="Escalated Breach" v-if="item.esc == 'true'"></BIconExclamationCircle>
            </template>
            <template #cell(detail)="row">
        <b-button v-if="row.item.date != ''" variant = 'outline-dark' size="sm" @click="showModal(row.item)">
         Detail
        </b-button>
      </template>
        </b-table>

    </b-card>
    <b-modal
    ref="DetailModal"
        id="DetailModal"
        title="Detail"
        content-class="Modal"
        header-bg-variant="light"
        footer-bg-variant="light"
        lazy
        ok-only
        size = "sm">
      <b-card>
        <b-card-body>
        <b-row class="breach"><b-col><b>Compliance Breach</b></b-col></b-row>
        <b-row><b-col><b>Device:</b></b-col></b-row>
        <b-row><b-col>{{ Passeditem.Device }}</b-col></b-row>
        <b-row><b-col><b>Breach Date:</b> </b-col></b-row>
        <b-row><b-col>{{ Passeditem.date }}</b-col></b-row>
        <b-row><b-col><b>Note:</b> </b-col></b-row>
        <b-row><b-col>{{ Passeditem.note }}</b-col></b-row>
        <b-row><b-col><b-badge variant="dark" v-if="Passeditem.esc == true">ESCALATED</b-badge></b-col></b-row>
        
      </b-card-body>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import { BIconExclamationCircle } from 'bootstrap-vue/dist/bootstrap-vue.esm';
import axios from "axios";

export default {
    data() {
        return {
            selectedlocation: localStorage.getItem("CurrentLocation"),
            CurrentName: localStorage.getItem("fullname"),
            filter: 7,
            today: null,
            options:[
              {value: 7, text: 'Last 7 days'},
              {value: 14, text: 'Last 14 days'},
              {value: 28, text: 'Last 28 days'}
            ],
            fields: [
          {
            key: 'Device', label: 'ID',thStyle: { width: "10%"}, 
          },
          {
            key: 'Position',label: 'Position',thStyle: { width: "20%" },
          },
          {
            key:'Probe',label:'Probe',thStyle:{width: "5%"}
          },
          {
            key: 'DeviceTag',label:'Tag',thStyle: { width: "8%" },
          },
          {
            key: 'Threshold',thStyle: { width: "8%" },label: 'Threshold', variant:'warning'
          },
          {
            key: 'DeviceMax',thStyle: { width: "8%" },label: 'Max'
          },
          {
            key: 'DeviceMin',thStyle: { width: "8%" },label: 'Min'
          },
          {
            key: 'DeviceAvg',thStyle: { width: "8%" },label: 'Avg'
          },
          {
            key: 'FlowThreshold',thStyle: { width: "8%" },label: 'Threshold',variant:'warning'
          },
          {
            key: 'DeviceFlow',thStyle: { width: "8%" },label: 'Flow'
          },
          {
            key: 'detail',thstyle:{width:"5%"},label: 'Detail'
          }

        ],
        Passeditem: { 'Device': '',
            'Position':'',
            'DeviceTag':'',
            'Threshold':'',
            'DeviceMax':'',
            'DeviceMin':'',
            'DeviceAvg':'',
            'Timer': '',
            'FlowThreshold':'',
            'DeviceFlow':'',
            'esc':'',
            'date': '',
            'note': ''},
        items: [],
        BreachValues: [],
        SOCValues:[],
        SummaryValues:[]
      
        }
    },
    computed: {},
    components: {
        BIconExclamationCircle,
    },
    mounted(){
      this.BreachLookup(this.filter);

    },
    methods:{
      showModal(item){
        this.Passeditem = item
        this.$refs["DetailModal"].show();
      },
      changeFilter(){
        let filtervalue = this.filter
        this.BreachLookup(filtervalue)
      },
     
      BreachLookup(filter){


        let LookUpURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/breach";
        let LookUpHeaders = this.$apikeyPost;
        let LookUpRequest = {
          RequestType: "BreachTable",
          Location: this.selectedlocation,
          DateRange: filter
        };

        axios.post(LookUpURL, LookUpRequest, LookUpHeaders).then((response) => {
          let responseArray = response.data.DeviceList
          this.items = []
          
          for (let x = 0; x < responseArray.length; x++){
            let cellvarparam = {}

            if(responseArray[x][12] == 'Flow'){
              responseArray[x][14] = '-'
              cellvarparam = {
                DeviceFlow: 'danger'
              }
            } else if(responseArray[x][12]=='Max'){
              responseArray[x][13][5] = '-'
              cellvarparam = {
                DeviceMin: 'danger'
              }
            } else if (responseArray[x][12]=='Min'){
              responseArray[x][13][5] = '-'
              cellvarparam = {
                DeviceMax: 'danger'
              }
            } else if(responseArray[x][12]=='Avg'){
              responseArray[x][13][5] = '-'
              cellvarparam = {
                DeviceAvg: 'danger'
              }
            }
            let escparam = false
            if (responseArray[x][8] == 'Escalated'){
              escparam = true
            }
            
            this.items.push({
              "Device":responseArray[x][1],
              "Position":responseArray[x][11],
              "Probe":responseArray[x][2],
              "DeviceTag":responseArray[x][6],
              "Threshold":responseArray[x][14]+'\xB0c',
              'DeviceMax':responseArray[x][13][0]+'\xB0c',
              'DeviceMin':responseArray[x][13][1]+'\xB0c',
              'DeviceAvg':responseArray[x][13][2]+'\xB0c',
              'FlowThreshold': responseArray[x][15] + ' hours',
              'DeviceFlow': responseArray[x][13][5] + ' hours',
              'esc': escparam,
              'date': responseArray[x][3] + ' ' + responseArray[x][4],
              'note': responseArray[x][9],
              _cellVariants: cellvarparam


            })
          }
          });
      },

    },
    watch:{
      filter() {
      this.changeFilter();
    },
    }

}
</script>

<style>
.Head{
    text-align: center;
    font-size: small;
}
th{
    font-size: x-small;
}
tr{
    font-size: small;
}
.table-danger{
  background-color: white;
}
td.table-danger {
  border: 2px solid !important;;
  border-color: red !important;
  font-weight: bold;
}
.table thead th {
    vertical-align: bottom;
    border: none;
}
.tr{
  vertical-align: middle;
}
.table-warning{
  background-color: #ffc107;
}
.breach{
  background-color: #ffc107;
  color: black;
}
</style>